import { IObservable, Subject } from '~/rage/utils';
import { Layouts } from '~/shared';
import { IGuiService, MinimapInfo } from './guiServiceTypes';

export abstract class AbstractGuiService implements IGuiService {
	protected minimapInfo = new Subject<MinimapInfo>({
		x: -9999,
		y: 0,
		width: 0,
		height: 0,
	});

	private visible = new Subject<boolean>(true);
	private visibleLayouts = new Subject<Layouts[]>([]);
	private layoutStates = new Map<Layouts, Subject<boolean>>();

	private hudVisible = new Subject<boolean>(false);

	constructor() {
		(global as any).setGuiVisible = (visible: boolean) => {
			this.setVisibleState(visible);
		};

		(global as any).setLayoutVisible = (name: Layouts, visible: boolean) => {
			this.setLayoutVisibleState(name, visible);
		};
	}

	public getVisibleState(): IObservable<boolean> {
		return this.visible;
	}

	public setVisibleState(visible: boolean): void {
		this.visible.next(visible);
	}

	public getLayoutVisibleState(name: Layouts): IObservable<boolean> {
		if (!this.layoutStates.has(name)) {
			this.layoutStates.set(name, new Subject(false));
		}

		return this.layoutStates.get(name)!;
	}

	public getVisibleLayouts(): IObservable<Layouts[]> {
		return this.visibleLayouts;
	}

	public setLayoutVisibleState(name: Layouts, visible: boolean): void {
		if (!this.layoutStates.has(name)) {
			this.layoutStates.set(name, new Subject(false));
		}

		this.layoutStates.get(name)!.next(visible);

		const visibleLayouts = Array.from(this.layoutStates.entries())
			.filter(([, state]) => state.getValue())
			.map(([name]) => name);
		this.visibleLayouts.next(visibleLayouts);
	}

	public async shouldDeclineInvite(): Promise<boolean> {
		return false;
	}

	public abstract setCursorVisible(
		name: string,
		isVisible: boolean,
	): Promise<void>;

	public isHudVisible(): IObservable<boolean> {
		return this.hudVisible;
	}

	public setHudVisible(isVisible: boolean): void {
		this.hudVisible.next(isVisible);
	}

	public abstract setGameHudVisible(isVisible: boolean): Promise<void>;

	public getMinimapInfo(): IObservable<MinimapInfo> {
		return this.minimapInfo;
	}
}
